var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 19.5q-2.068 0-3.534-1.477Q2 16.547 2 14.414q0-1.828 1.068-3.258a4.7 4.7 0 0 1 2.796-1.828q.568-2.155 2.272-3.492A6.1 6.1 0 0 1 12 4.5q2.66 0 4.511 1.91 1.853 1.91 1.853 4.653a3.93 3.93 0 0 1 2.602 1.394Q22 13.664 22 15.281q0 1.758-1.193 2.989t-2.898 1.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFill);
export default __webpack_public_path__ + "static/media/cloud_fill.bade024a2802ef211007012992e2a178.svg";
export { ForwardRef as ReactComponent };